import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import {
	BlackOverlay,
	CompleteAnim,
	ErrorAnim,
	MplButton,
	MplModal,
} from '@mopla/ui';

interface IPaymentSuccessModalProps {
	open: boolean;
	onConfirm: () => void;
}

export const PaymentSuccessModal: FC<IPaymentSuccessModalProps> = ({
	open,
	onConfirm,
}) => {
	const { t } = useTranslation('ticketshop');

	return (
		<>
			<BlackOverlay open={open} />
			<MplModal
				open={open}
				testId="operator-ticket-payment-success-modal"
				icon={<CompleteAnim />}
				title={t('payment.success_modal.title')}
				content={
					<Typography variant="body1" color="primary.main">
						{t('payment.success_modal.description')}
					</Typography>
				}
				buttons={
					<MplButton
						fullWidth
						onClick={onConfirm}
						testId="operator-ticket-payment-success-button"
					>
						{t('payment.success_modal.button')}
					</MplButton>
				}
			/>
		</>
	);
};

interface IPaymentFailureModalProps {
	open: boolean;
	onClose: () => void;
}

export const PaymentFailureModal: FC<IPaymentFailureModalProps> = ({
	open,
	onClose,
}) => {
	const { t } = useTranslation('ticketshop');

	return (
		<>
			<BlackOverlay open={open} />
			<MplModal
				open={open}
				testId="operator-ticket-payment-failure-modal"
				icon={<ErrorAnim loop />}
				title={t('payment.failure_modal.title')}
				content={
					<Typography
						variant="body1"
						color="primary.main"
						sx={{ whiteSpace: 'pre-line' }}
					>
						{t('payment.failure_modal.description')}
					</Typography>
				}
				buttons={
					<MplButton
						fullWidth
						onClick={onClose}
						testId="operator-ticket-payment-failure-button"
					>
						{t('payment.failure_modal.button')}
					</MplButton>
				}
			/>
		</>
	);
};
